import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPackage, FiTruck, FiMapPin, FiHeart, FiArrowRight, FiCheckCircle, FiStar, FiAward, FiShield, FiGlobe } = FiIcons;

const JourneySection = ({ nextStep, t }) => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      name: "TL",
      location: "HongKong",
      story: "Excellent service from Keyman. Very professional and knowledgable about the brand and design. Able to provide recommendations based on our preferred style and taste. We were able to select and purchase our desirable wedding band. Highly recommend to shop here!",
      rating: 5,
      image: "https://lh3.googleusercontent.com/a-/ALV-UjVATLHDRgJtN_ccfo7j2LmVrMuIcgX_OfaiYWj6PABdfd1yIxAI=w80-h80-c-rp-mo-br100"
    },
    {
      name: "Ho Seng",
      location: "HongKong",
      story: "介紹產品高質 員工推廣緊自己公司既product 講解得幾好 成個流程都好舒服",
      rating: 5,
      image: "https://lh3.googleusercontent.com/a/ACg8ocKUqgGG7Mj3-GNY0a6aMY5ROYs_cxh-bLmlmheE3ki2VWlVQQ=w80-h80-c-rp-mo-br100"
    },
    {
      name: "Leia",
      location: "HongKong",
      story: "非常好！Krystal 服務很好，講解非常專業，有耐心，愉快的選購體驗，選到了滿意的鑽石戒指👍",
      rating: 5,
      image: "https://lh3.googleusercontent.com/a/ACg8ocL8dKBrE8BZmAkj8S6VrskwBbbmr2nEJQdAvPr_qhvPCDCnog=w80-h80-c-rp-mo-br100"
    },
    {
      name: "Tommy LI",
      location: "HongKong",
      story: "Good services and nice products quality",
      rating: 5,
      image: "https://lh3.googleusercontent.com/a/ACg8ocKR1FCb0KxS6wszw8y_4voAeT6cs9mu9CElj7WTfi7mnLAaew=w80-h80-c-rp-mo-br100"
    }
  ];

  const timelineSteps = [
    {
      id: 1,
      title: t('ginzaDiamondTitle1'),
      content: [t('ginzaDiamondContent1'), t('ginzaDiamondContent2')],
      icon: FiAward
    },
    {
      id: 2,
      title: t('ginzaDiamondTitle2'),
      content: [t('ginzaDiamondContent3'), t('ginzaDiamondContent4')],
      icon: FiShield
    },
    {
      id: 3,
      title: t('ginzaDiamondTitle3'),
      content: [t('ginzaDiamondContent5')],
      icon: FiGlobe
    },
    {
      id: 4,
      title: t('ginzaDiamondTitle4'),
      content: [t('ginzaDiamondContent6'), t('ginzaDiamondContent7')],
      icon: FiStar
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-rose-400 to-pantone-blue bg-clip-text text-transparent">
            {t('journeyTitle')}
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('journeyDescription')}
          </p>
        </motion.div>

        {/* Vertical Timeline for Ginza Diamond Shiraishi */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mb-16"
        >
          <div className="bg-gradient-to-br from-pantone-blue/20 to-blue-900/20 backdrop-blur-sm border border-pantone-blue/20 rounded-3xl p-8">
            <h2 className="text-3xl font-bold text-center text-white mb-8">
              Ginza Diamond Shiraishi Story
            </h2>
            
            {/* Vertical Timeline */}
            <div className="relative">
              {/* Timeline line */}
              <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-pantone-blue/50 transform -translate-x-1/2"></div>
              
              {/* Timeline items */}
              <div className="space-y-12">
                {timelineSteps.map((step, index) => (
                  <motion.div
                    key={step.id}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className="relative pl-20"
                  >
                    {/* Timeline dot */}
                    <div className="absolute left-8 top-6 w-6 h-6 rounded-full bg-pantone-blue border-4 border-blue-900 transform -translate-x-1/2"></div>
                    
                    {/* Icon */}
                    <div className="absolute left-8 top-4 w-10 h-10 rounded-full bg-gradient-to-r from-pantone-blue to-blue-500 flex items-center justify-center transform -translate-x-1/2">
                      <SafeIcon icon={step.icon} className="w-5 h-5 text-white" />
                    </div>
                    
                    {/* Content */}
                    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
                      <h3 className="text-2xl font-bold text-white mb-4">{step.title}</h3>
                      {step.content.map((paragraph, i) => (
                        <p key={i} className="text-lg text-gray-300 leading-relaxed mb-4 last:mb-0">
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>

        {/* Customer Stories */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-center text-white mb-8">{t('storiesOfLove')}</h2>
          <div className="relative max-w-4xl mx-auto">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentTestimonial}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
                className="bg-gradient-to-br from-rose-900/20 to-pantone-blue/20 backdrop-blur-sm border border-rose-500/20 rounded-2xl p-8"
              >
                <div className="flex items-center mb-6">
                  <img
                    src={testimonials[currentTestimonial].image}
                    alt={testimonials[currentTestimonial].name}
                    className="w-16 h-16 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h3 className="text-xl font-semibold text-white">{testimonials[currentTestimonial].name}</h3>
                    <p className="text-gray-400">{testimonials[currentTestimonial].location}</p>
                    <div className="flex mt-1">
                      {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                        <SafeIcon key={i} icon={FiStar} className="w-4 h-4 text-yellow-400 fill-current" />
                      ))}
                    </div>
                  </div>
                </div>
                <blockquote className="text-lg text-gray-300 italic leading-relaxed">
                  "{testimonials[currentTestimonial].story}"
                </blockquote>
              </motion.div>
            </AnimatePresence>

            {/* Testimonial Navigation */}
            <div className="flex justify-center mt-6 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentTestimonial
                      ? 'bg-rose-500'
                      : 'bg-gray-600 hover:bg-gray-500'
                  }`}
                />
              ))}
            </div>
          </div>
        </motion.div>

        {/* Emotional Connection */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="text-center mb-12"
        >
          <div className="bg-gradient-to-r from-purple-600/20 to-pantone-blue/20 backdrop-blur-sm border border-purple-500/20 rounded-2xl p-8 max-w-4xl mx-auto">
            <SafeIcon icon={FiHeart} className="w-16 h-16 text-pink-400 mx-auto mb-6" />
            <h3 className="text-3xl font-semibold mb-6 text-white">{t('moreThanDiamond')}</h3>
            <p className="text-lg text-gray-300 leading-relaxed mb-6">
              {t('moreThanDescription')}
            </p>
            <div className="grid md:grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="text-2xl font-bold text-pink-400 mb-2">100%</div>
                <div className="text-gray-300">{t('satisfactionGuarantee')}</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-pink-400 mb-2">Lifetime</div>
                <div className="text-gray-300">{t('lifetimeSupport')}</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-pink-400 mb-2">Forever</div>
                <div className="text-gray-300">{t('foreverMemories')}</div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Continue Button */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="text-center"
        >
          <button
            onClick={nextStep}
            className="group bg-gradient-to-r from-rose-600 to-pantone-blue hover:from-pantone-blue hover:to-rose-600 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-xl transition-all duration-300 flex items-center gap-3 mx-auto"
          >
            {t('completeJourney')}
            <SafeIcon icon={FiArrowRight} className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default JourneySection;